import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postJobLabour = async ({ serviceId, date, hours }: JsonDataItem) => {
  const { data } = await baseQuery('job-labour', {
    type: 'POST',
    body: {
      date: date,
      hours: hours,
      job_id: serviceId,
    },
  });

  return data;
};
